export const DISABLED_UNTIL_JS_READY_DATA_ATTR_NAME = "data-disable-until-js-ready";
